<!-- Custom Fullscreen Image Viewer with Zoom & Pan -->
<div *ngIf="showFullscreenViewer" class="fullscreen-viewer-overlay" (wheel)="onViewerWheel($event)" (mouseup)="onViewerMouseUp()" (mousemove)="onViewerMouseMove($event)" (mouseleave)="onViewerMouseUp()">
    <div class="fullscreen-viewer-toolbar">
        <button class="viewer-btn" (click)="viewerZoomIn()" title="Zoom In"><i class="fa fa-search-plus"></i></button>
        <button class="viewer-btn" (click)="viewerZoomOut()" title="Zoom Out"><i class="fa fa-search-minus"></i></button>
        <span class="viewer-zoom-label">{{ (viewerZoomLevel * 100) | number:'1.0-0' }}%</span>
        <button class="viewer-btn" [ngClass]="{'viewer-btn-active': viewerBoxZoomMode}" (click)="toggleBoxZoomMode()" title="Box Zoom"><i class="fa fa-crop"></i></button>
        <button class="viewer-btn" (click)="viewerResetView()" title="Reset"><i class="fa fa-undo"></i></button>
        <button class="viewer-btn viewer-btn-close" (click)="closeFullscreenViewer()" title="Close"><i class="fa fa-times"></i></button>
    </div>
    <div class="fullscreen-viewer-container">
        <div *ngIf="viewerImageLoading" style="display: flex; align-items: center; gap: 10px;">
            <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="color: white;"></i>
            <span style="color: white; font-size: 16px;">Loading...</span>
        </div>
        <img *ngIf="!viewerImageLoading && viewerImageSrc"
             [src]="viewerImageSrc"
             [style.transform]="'scale(' + viewerZoomLevel + ') translate(' + viewerPanX + 'px, ' + viewerPanY + 'px)'"
             [style.cursor]="viewerBoxZoomMode ? 'crosshair' : (viewerZoomLevel > 1 ? 'grab' : 'default')"
             (mousedown)="onViewerMouseDown($event)"
             draggable="false"
             class="fullscreen-viewer-image"
             alt="Fullscreen preview" />
        <div *ngIf="boxZoomActive" class="box-zoom-selection"
             [style.left.px]="getBoxRect().left"
             [style.top.px]="getBoxRect().top"
             [style.width.px]="getBoxRect().width"
             [style.height.px]="getBoxRect().height"></div>
    </div>
</div>

<div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="cameraSettings-modal">
<!-- <div class="modal-content cameraSettings-modal"> -->
    <p-confirmDialog #cd>
        <ng-template pTemplate="footer">
          <button (click)="cd.reject()" class="btn btn-basic" type="button">No</button>
          <button (click)="cd.accept()" class="btn btn-success" type="button">Yes</button>
          <div class="far fa-comment pull-right" style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px" aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
        </ng-template>
    </p-confirmDialog>

    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <!-- <h5 *ngIf="selectedDevice.versionInfo == ''" class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">
            Camera Actions&nbsp;<i *ngIf="!eventsLoaded" class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
        </h5>
        
        <h4 *ngIf="selectedDevice.versionInfo != ''" class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">
            Camera Actions&nbsp;<i *ngIf="!eventsLoaded" class="fa fa-spinner fa-spin fa-1x fa-fw"></i>(Scoutview gateway less than v5.6.0 or is not responding. Camera may not work)
        </h4>        -->

        <div style="display: flex;">
            <span style="font-size: 22px; margin-top: -4px;">Camera Actions &nbsp; &nbsp;</span>
            <label *ngIf="selectedDevice.versionWarning" style="font-size: 16px; color: #FF0000;">(Scoutview gateway version is less than v5.6.0 or has not responded. Camera may not work)</label>
        </div>
        

        <button
            (click)="bsModalRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
        </button>
    </div>

    <div class="modal-body" *ngIf="eventsLoaded">
        <div class="container-fluid">
            <div style="margin-bottom: 20px; display: flex; gap: 20px;">
                <div class="form-group" style="width: 400px;">
                    <label for="selectedDevice">Scoutview System</label>
                    <ngx-select-dropdown name="selectedDevice" [config]="deviceConfig" [options]="imageDevices" [(ngModel)]="selectedDevice" (change)="updateSelectedDevice($event.value)"></ngx-select-dropdown>
                </div>

                <div class="form-group" style="width: 380px;">
                    <label for="owner">Owner</label>
                    <input [(ngModel)]="selectedDeviceOwner" class="form-control" id="owner" name="owner" required type="text" disabled=true style="height: 38px; border-color: lightgray; color: black;" />
                </div>

                <div class="form-group" style="width: 120px;">
                    <label for="owner">Mounting Angle</label>
                    <input [(ngModel)]="selectedDevice.mountAngle" class="form-control" id="CameraOrientation" name="CameraOrientation" required type="text" disabled=true style="height: 38px; border-color: lightgray; color: black;" />
                </div>
            </div>
        </div>

        <tabset> 
            <tab heading="Capture and Control" class="tabset">
                <div style="margin-left: 55px; display: flex; gap: 60px;">

                    <div *ngFor="let camera of selectedDevice.deviceCameras; let i = index" style="min-width: 395px; max-width: 395px; margin-top: 10px; display: block;">
                        <div *ngIf="i < 2">
                            <label style="margin-top: 5px; font-weight: 500;">Preview {{i + 1}}</label>
                            <div style="margin-bottom: 15px;">
                                <ngx-select-dropdown name="{{'cameraPreview' + i}}" [config]="cameraConfig" [options]="selectedDevice.deviceCameras" [(ngModel)]="cameraPreview[i].deviceCamera" (change)="clearPreview(i)"></ngx-select-dropdown>
                            </div>

                            <div  style="max-width:100%; height: auto; min-height: 224px; border: 1px solid darkgray;" >
                                <div *ngIf="cameraPreview[i].scoutview.latestThumbnail.isLoading" style="display: flex; margin-top:80px">
                                    <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 10px;"></i>
                                    <span style="padding-top: 15px;">Capturing and loading ...</span>
                                </div>

                                <div *ngIf="cameraPreview[i].scoutview.latestThumbnail.isLoading == false">
                                    <div *ngIf="cameraPreview[i].scoutview.latestThumbnail.blobName.endsWith('.jpg')" style="width: 100%;" >
                                        <img src="{{cameraPreview[i].scoutview.latestThumbnail.source}}" alt="Image" style="width: 393px; cursor: pointer;" (click)="openFullscreenViewer(cameraPreview[i].scoutview)" />
                                    </div>
                                    
                                    <div *ngIf="cameraPreview[i].scoutview.image.blobName.endsWith('.mp4')" style="width: 100%;" >
                                        <video width="395" controls>
                                            <source src="{{cameraPreview[i].scoutview.image.source}}" type="video/mp4">
                                        </video>
                                    </div>
                                </div>
                                
                                <!-- <div *ngIf="cameraPreview[i].scoutview.image.blobName.endsWith('.webm') && cameraPreview[i].scoutview.latestThumbnail.isLoading == false" style="width: 100%;" >
                                    <video width="395" controls>
                                        <source src="{{cameraPreview[i].scoutview.image.source}}" type="video/webm">
                                        Your browser does not support the video tag.
                                    </video>
                                </div> -->
                            </div>

                            <div style="display: flex; margin-bottom: 10px; margin-top: -1px; height: 40px; background-color: #548235; border: 1px solid darkgray;">
                                <button name="captureImageNow" (click)="captureImageNow(i, true, cameraPreview[i].deviceCamera)" [disabled]="!selectedDevice.userFeatureAccess['EditDevice']" style="height: 35px; width: 40px; margin-left: 10px; border: none; font-size: 18px; color: white;" class="btn" type="button"><i class="fa-solid fa-rotate"></i></button>
                                <button name="captureImageNow" (click)="captureImageNow(i, false, cameraPreview[i].deviceCamera)" [disabled]="!selectedDevice.userFeatureAccess['EditDevice']" style="height: 35px; width: 40px; margin-left: 15px; border: none; font-size: 18px; color: white;" class="btn" type="button"><i class="fa-solid fa-camera"></i></button>
                                <!-- <div *ngIf="cameraPreview[i].deviceCamera.model.includes('ArduCam')" style="display: flex;"> -->
                                    <button name="captureVideoNow" (click)="captureVideoNow(i)" [disabled]="!selectedDevice.userFeatureAccess['EditDevice']" style="height: 35px; width: 40px; margin-left: 15px; border: none; font-size: 18px; color: white;" class="btn" type="button"><i class="fa-solid fa-video"></i></button>
                                    <input [(ngModel)]="captureVideoNowDuration" min=5 max=60 class="form-control" style="font-size: 14px; height: 30px; width: 60px; margin-top: 4px;" id="videoDuration" name="videoDuration" required type="number" />
                                    <label for="videoDuration" style="font-size: 14px; margin-top: 8px; margin-left: 6px; color: white;">sec</label>
                                <!-- </div> -->
                                <button *ngIf="cameraPreview[i].deviceCamera.model.includes('PTZ')" name="ptzControl" (click)="ptzCameraControl(i, ptzCameraControlTemplate)" style="height: 30px; margin-left: 40px; margin-top: 4px; background-color: white;" class="btn btn-sm pull-right" type="button">PTZ Control</button>
                            </div>

                            <label style="margin-top: 5px;">Identifier (Image Tag)</label>
                            <input [(ngModel)]="cameraPreview[i].imageTags" (ngModelChange)="propagateImageTagChanges(i)" class="form-control" style="font-size: 14px; height: 35px; width: 100%; margin-bottom: 20px;" id="videoDuration" name="videoDuration" required type="text" />
                        </div>
                    </div> 
                </div>

                <div *ngIf="selectedDevice.deviceCameras != undefined && selectedDevice.deviceCameras.length > 1" style="margin-left: 55px; justify-content: center; display: flex; gap: 10px;">
                    <button *ngIf="previewImageTagsLinked" (click)="toggleLinkingOfPreviewImageTags()" name="linkPreviews"  style="height: 38px;" class="btn btn-primary" type="button"><i class="fa-solid fa-link"></i> Image Tags</button>
                    <button *ngIf="!previewImageTagsLinked" (click)="toggleLinkingOfPreviewImageTags()" name="linkPreviews"  style="height: 38px;" class="btn btn-primary" type="button"><i class="fa-solid fa-link-slash"></i> Image Tags</button>
                    <button (click)="snapShotAllPreviewsAndClearTagsOnSuccess()" name="captureAndClear" style="height: 38px; margin-bottom: 20px;" class="btn btn-primary" type="button">Capture All Then Clear Tags</button>
                </div>
            </tab>

            <tab heading="Camera Events and Actions" class="tabset">
                <p-table #sensorTable [columns]="cameraEventsCols" [scrollable]="true" [value]="associatedCameraEvents" scrollHeight="30vh" sortMode="multiple">
        
                    <ng-template let-columns pTemplate="header">
                        <tr style="height: 35px;">
                            <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>
        
                    <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                        <tr *ngIf="rowData.userFeatureAccess['ViewListing'] || global.globalSwitch" style="height: 40px;" >

                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;" >
                                {{ rowData.name }}
                            </td>

                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;" >
                                <span *ngIf="rowData.eventActions.length > 0">
                                    {{ rowData.eventActions[0].type }}
                                </span> 
                                <span *ngIf="rowData.eventActions.length > 1">
                                    ...&nbsp;({{rowData.eventActions.length}})
                                </span> 
                            </td>

                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;">
                                <!-- {{rowData.eventType | slice:0:1}} -->
                                {{ rowData.eventType }}
                            </td>
                    
                            <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                                {{ rowData.modifiedDate | date : 'medium'}}
                            </td>
                    
                            <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                                {{!rowData.isDisabled ? 'True' : 'False'}}
                            </td>

                            <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;" >
                                <div *ngIf="rowData.userFeatureAccess['EditEvent']" 
                                    (click)="editEvent(rowData)" aria-hidden="true"
                                    class="fas fa-pencil-alt" style="color:#64a70b; cursor: pointer; font-size: 14px;">
                                </div>
                                <div *ngIf="rowData.userFeatureAccess['ViewEvent'] && !rowData.userFeatureAccess['EditEvent']"
                                    (click)="editEvent(rowData)" aria-hidden="true"
                                    class="far fa-eye" style="color:#1c4966; cursor: pointer; font-size: 14px;">
                                </div>
                            </td>
                    
                            <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;">
                                <div *ngIf="rowData.userFeatureAccess['DeleteEvent']" >
                                <div (click)="onDeleteConfirm(rowData)" aria-hidden="true" class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;"></div>
                                <span class="sr-only">Delete</span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <button (click)="addEvent()" style="height: 38px; margin: 15px;" class="btn btn-success" type="button">Create Event</button>
            </tab>
        </tabset>
            
        <button (click)="bsModalRef.hide()" style="height: 38px; margin-top: 15px; margin-bottom: 15px;" class="btn btn-primary pull-right" type="button">Close</button>
    </div>
</div>
  
  
<ng-template #ptzCameraControlTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="ptzCameraControl-modal" style="min-height: 600px;">
    <!-- <div class="modal-content ptzCameraControl-modal" style="min-height: 600px;"> -->
        <p-confirmDialog key="openbrowser" #openbrowser>
            <ng-template pTemplate="footer">
              <button (click)="openbrowser.reject()" class="btn btn-basic" type="button">Skip</button>
              <button (click)="openbrowser.accept()" class="btn btn-success" type="button">Continue</button>
            </ng-template>
        </p-confirmDialog>

        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">PTZ Camera Control</h5>
            <button
                (click)="ptzCameraControlRef.hide()"
                class="ms-auto fas fa-times" type="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>

        <div class=" modal-body" [ngStyle]="{'background-color':'#595959'}" style="margin-top: -1px; padding: 0px;">
            <i *ngIf="waitingForPTZResponse" class="fa fa-spinner fa-spin fa-1x fa-fw" style="margin-top: 25px; color: gray; position: fixed; top: 0; left: 230px;"></i>

            <div *ngIf="ptzImageblobName.endsWith('.jpg')" style="max-width:100%; height: auto; margin-top: 42px;" >
                <img src="{{ptzImagePreview}}" class="img-scale-down" style="max-width:100%; height: auto;" />
            </div>

            <div style="display: flex; gap: 3px; background-color: rgb(167, 167, 167); font-size: 15px; padding: 3px; width: 100%; margin-top: 56px; position: fixed; top: 0; left: 0;">
                <!-- <label style="margin-top: 7px; margin-left: 6px; width: 210px;">Loc: {{ selectedCameraPreset.locId }}, Focus: {{ ptzCameraFocus }}, Zoom: {{ ptzCameraZoom }}</label> -->
                <label style="margin-top: 7px; margin-left: 6px; width: 210px;">Loc: {{ selectedCameraPreset.locId }}, Focus: {{ selectedCameraPreset.focus }}, Zoom: {{ selectedCameraPreset.zoom }}</label>
                
                <input type="checkbox" [(ngModel)]="ptzCameraAutoFocus" name="autofocus" style="width: 15px; height: 30px; margin-right: 2px; margin-top: 3px; margin-left: 20px;" />
                <label style="margin-top: 7px;">AutoFocus</label>

                <label style="margin-top: 7px; margin-left: 20px;">Name</label>
                <input type="text" [(ngModel)]="selectedCameraPreset.name" name="presetName" style="width: 300px; height: 30px; margin-right: 5px; margin-top: 3px;" (ngModelChange)="common.removeReservedCharsInPresets(selectedCameraPreset)"/>

                <button (click)="ptzControl('setpreset', selectedCameraPreset.locId)" style="height: 30px; width: 60px; margin-right: 50px; margin-top: 3px;" class="btn btn-success btn-sm" type="button">Save</button>
                
                <ng-select [items]=selectedCamera.presets
                    name="CameraPresets"
                    style="width: 540px; height: 36px;"
                    bindLabel="displayText"
                    (change) = "selectedCameraPresetChanged($event)"
                    placeholder = "Select camera location to 'Save' or to 'Goto'"
                    (clear) = "newCameraPresetSelection()"
                    [(ngModel)]="selectedCameraPreset">
                </ng-select>

                <button (click)="ptzControl('gotopreset', selectedCameraPreset.locId)" style="height: 30px; width: 60px; margin-top: 3px;" class="btn btn-primary btn-sm" type="button">Goto</button>
            </div>

            <div style="border: 1px dotted lightgray; background-color: rgb(167, 167, 167); padding: 3px; width: 165px; margin-left: 10px; margin-top: 108px; position: fixed; top: 0; left: 0;">
                <div style="display: flex; gap: 6px;" class="text-center">
                    <div class="form-group" style="width: 70px;">
                        <label for="ptzCameraStep" style="font-size: 14px; color: white;">Step</label>  
                        <input type="number" [(ngModel)]="ptzCameraStep" name="ptzCameraStep" style="width: 45px;" min="0" max="99"/>
                    </div>
                    <div>
                        <button (click)="ptzControl('up', 10)" style="color: rgb(49, 49, 49); font-size: 28px; border: 1px solid gray; padding: 2px; margin-bottom: 3px;" class="fa-solid fa-angles-up btn-sm" type="button"></button>
                        <button (click)="ptzControl('up', 1)" style="color: rgb(49, 49, 49); font-size: 28px; border: 1px solid gray; padding: 2px;" class="fa-solid fa-angle-up btn-sm" type="button"></button>
                    </div>
                    <div class="form-group" style="width: 70px;">
                        <label for="ptzCameraFocus" style="font-size: 14px; color: white;">Focus</label>  
                        <input [(ngModel)]="ptzCameraFocus" name="ptzCameraFocus" style="width: 42px;"  (keyup.enter)="ptzControl('focus', ptzCameraFocus)"/>
                    </div>
                </div>

                <div style="display: flex; gap: 2px; margin-top: 3px;" class="text-center">
                    <button (click)="ptzControl('left', 10)" style="color: rgb(49, 49, 49); font-size: 28px; border: 1px solid gray; padding: 2px;" class="fa-solid fa-angles-left btn-sm" type="button"></button>
                    <button (click)="ptzControl('left', 1)" style="color: rgb(49, 49, 49); font-size: 28px; border: 1px solid gray; padding: 2px;" class="fa-solid fa-angle-left btn-sm" type="button"></button>
                    <button (click)="ptzControl('refresh', 1)" style="color: rgb(49, 49, 49); font-size: 26px; border: 1px solid gray; padding: 2px;" class="fa-solid fa-arrows-rotate btn-sm" type="button"></button>
                    <button (click)="ptzControl('right', 1)" style="color: rgb(49, 49, 49); font-size: 28px; border: 1px solid gray; padding: 2px;" class="fa-solid fa-angle-right btn-sm" type="button"></button>
                    <button (click)="ptzControl('right', 10)" style="color: rgb(49, 49, 49); font-size: 28px; border: 1px solid gray; padding: 2px;" class="fa-solid fa-angles-right btn-sm" type="button"></button>
                </div>

                <div style="display: flex; gap: 14px; margin-top: 3px; margin-left: 5px;" class="text-center">
                    <div style="margin-top: 5px;">
                        <div style="margin-bottom: 2px;">
                            <button (click)="ptzControl('zoomout', 0.1)" style="color: rgb(49, 49, 49); font-size: 24px; border: 1px solid gray; padding: 2px;" class="fa-solid fa-magnifying-glass-minus btn-sm" type="button"></button>
                            <button (click)="ptzControl('zoomin', 0.1)" style="color: rgb(49, 49, 49); font-size: 24px; border: 1px solid gray; padding: 2px;" class="fa-solid fa-magnifying-glass-plus btn-sm" type="button"></button>
                        </div>
                    </div>
                    <div>
                        <div>
                            <button (click)="ptzControl('down', 1)" style="color: rgb(49, 49, 49); font-size: 28px; border: 1px solid gray; padding: 2px; margin-bottom: 3px;" class="fa-solid fa-angle-down btn-sm" type="button"></button>
                            <button (click)="ptzControl('down', 10)" style="color: rgb(49, 49, 49); font-size: 28px; border: 1px solid gray; padding: 2px;" class="fa-solid fa-angles-down btn-sm" type="button"></button>
                        </div>
                    </div>
                    <div class="form-group" style="width: 70px;">
                        <label for="ptzCameraZoom" style="font-size: 14px; color: white;">Zoom</label>  
                        <input [(ngModel)]="ptzCameraZoom" name="ptzCameraZoom" style="width: 42px;" (keyup.enter)="ptzControl('zoom', ptzCameraZoom)"/>
                    </div>
                </div>

                <div style="margin-top: 3px;">
                    <button (click)="ptzControl('saveimage', 1)" style="height: 32px; width: 155px;" class="btn btn-primary btn-sm" type="button">Capture Image</button>
                    
                    <div style="display: flex; gap: 5px; margin-top: 3px;">
                        <button (click)="ptzControl('enableremoteaccess', enableRemoteAccessToCameraDuration)" style="height: 32px; width: 115px;" class="btn btn-primary btn-sm" type="button">Enable Remote</button>
                        <input type="text" [(ngModel)]="enableRemoteAccessToCameraDuration" name="duration" style="width: 30px; height: 32px;" class="text-center" />
                    </div>
                </div>

            </div>

        </div>

    </div>
</ng-template>


<ng-template #loading>
    <div class="col-xs-4 col-lg-3">
      <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
      <span>Loading...</span>
    </div>
</ng-template>